import React, { useState } from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { SectionWrapper, StyledCloudImage, StyledColumns, StyledList, StyledTextPairing, StyledListItem } from './CompletionSection.styles';
import { babyRegistryPageData } from '@data-ts/pages/baby-registry';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

const { completionDiscount } = babyRegistryPageData;

const products = [
  'baby-registry/universal-reg/products/product-5-v3.png',
  'baby-registry/universal-reg/products/product-2-v3.png',
  'baby-registry/universal-reg/products/product-1-v3.png',
  'baby-registry/universal-reg/products/product-3-v3.png',
  'baby-registry/universal-reg/products/product-4-v3.png',
];

export const CompletionSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <Box as="section" id="CompletionDiscount" backgroundColor="yellow1">
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <div />
      </LazyLoadWrapper>
      <SectionWrapper
        background={isVisible ? cloudAssetUrl(completionDiscount.background, { optimization: 'default' }) : ''}
        backgroundMobile={isVisible ? cloudAssetUrl(completionDiscount.mobileBackground, { optimization: 'default' }) : ''}
        alignItems={['start', 'center']}
        justifyContent="center"
        paddingTop={[8, 0]}
      >
        <StyledColumns centered>
          <Flex flexDirection="column" justifyContent="center">
            <StyledTextPairing
              eyebrow={completionDiscount.eyebrow}
              eyebrowVariant="sectionEyeBrow20"
              eyebrowColor="neutra4"
              titleVariant="hed56"
              titleColor="neutra6"
              titleTagName="h3"
              title={completionDiscount.title}
              body={completionDiscount.body}
              bodyVariant="dek20"
              bodyColor="neutra5"
              bodyMaxWidth="350px"
              alignment="center"
            />
          </Flex>
        </StyledColumns>
      </SectionWrapper>
      <StyledList>
        {products.map((src, index) => (
          <StyledListItem key={`completion-item-${index}`}>
            <StyledCloudImage src={src} height={140} optimization="default" />
          </StyledListItem>
        ))}
      </StyledList>
    </Box>
  );
};
